import React from 'react';
import { Flex, Image, Box, Text } from '@chakra-ui/react';
import logo from '../assets/logo.png';

const PulseLogoLoader = ({ text = "載入中...", ...props }) => {
    return (
        <Flex
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={900}
            align="center"
            justify="center"
            bg="white"
            direction="column"
            {...props}
        >
            <Box>
                <Image
                    src={logo}
                    alt="Natural Education"
                    h="100px" // Matched to LogoPulseLoader size
                    objectFit="contain"
                />
            </Box>
            {text && <Text mt={4} color="gray.600" fontWeight="medium">{text}</Text>}
        </Flex>
    );
};

export default PulseLogoLoader;
